import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IDrawsState } from ".";
import { DrawMemberStatus } from "../../pages/DrawPage/DrawItem";
import { IBalances } from "../../types/balances";

export interface IBuyTicketResponse {
    balances: IBalances;
    exp: number;
    drawId: number;
    membersCount: number;
    userStatus: DrawMemberStatus;
    userWeight: number;
    isSubscriber: boolean;
};

export const buyDrawTicket = createAsyncThunk<IBuyTicketResponse, { drawId: number, amount: number }>(
    'draws/buyDrawTicket',
    async ({drawId, amount }) => await api.draws.buyDrawTicket(drawId, amount)
);

export const buyDrawTicketHandler = (builder: ActionReducerMapBuilder<IDrawsState>) => {    
    builder
        .addCase(buyDrawTicket.pending, (state: IDrawsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(buyDrawTicket.fulfilled, (state: IDrawsState, action: PayloadAction<IBuyTicketResponse>) => {
            state.loading = false;
            const draw = state.items.find(draw => draw.drawId === action.payload.drawId);

            if (!draw) {
                state.error = 'Unable to buy draw ticket';
                return;
            }

            draw.userStatus = action.payload.userStatus;
            draw.userWeight = action.payload.userWeight;
            draw.membersCount = action.payload.membersCount;            
        })
        .addCase(buyDrawTicket.rejected, (state: IDrawsState) => {
            state.loading = false;
            state.error = 'Unable to buy draw ticket';
        });
};

export default buyDrawTicketHandler;